module.exports = __webpack_public_path__ + "img/patent07.0347b8af.png";